export default "__VITE_ASSET__408f6b08__"